import { createSwiper } from '../adapters/SwiperAdapter';

export const communityReviewsOnLoadHandler = () => {
    createSwiper('.communityReviews--swiper', {
        slidesPerView: 1,
        spaceBetween: 80,
        speed: 300,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
};